import React, { useState, useRef } from "react";
import { FaChevronRight, FaEllipsisH, FaVideo } from "react-icons/fa";
import "./ChatHeader.css";
import MenuItems from "./MenuItems";
import { sendMessage } from "../../../components/Header/Data";
import { GetZoomLink } from "../../../components/Header/Data2";
import { toast } from "react-toastify";
import { Tooltip } from "@mui/material";
import { setSelectedConversation } from "../../../redux/slices/MsgSlice";
import { useSocket } from "../../../contexts/SocketContext";
import { Col, Row } from "reactstrap";
import AllDropdowns from "./AllDropDowns/DropDowns";
import { useSelector, useDispatch } from "react-redux";

const ChatHeader = ({
  isMobileView,
  onBack,
  toggleDrawer,
  fetchMsgs,
  fetchData,
  isChatModal,
}) => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dispatch = useDispatch();
  const [zoomLink, setZoomLink] = useState("");
  const [loading, setLoading] = useState(false);
  const islogin = useSelector((state) => state.user.isLogin);
  const userinfo = useSelector((state) => state.user.userInfo);
  const user = islogin ? JSON.parse(userinfo) : null;
  const { sendNewMessage } = useSocket();
  const selectedConversation = useSelector(
    (state) => state.messages.selectedConvo
  );
  const { sampleAd, isChatModalOpen } = useSelector((state) => state.searchBar);
  const { users } = useSelector((state) => state.socket);

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const allUsers = Array.isArray(users) ? users : [];
  const otherPartyId =
    selectedConversation?.createdBy == user?.UserID
      ? selectedConversation?.customerId
      : selectedConversation?.createdBy;
  const online = allUsers.some(
    (user) => user.Id === otherPartyId && user.onlineStatus === "online"
  );

  function formatDate1(date) {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}-${month}-${day} ${hours}:${minutes}`;
  }
  const now = new Date();
  const formattedDate = formatDate1(now);

  const formatLastOnline = (otherPartyId) => {
    const user = allUsers.find((user) => user.Id === otherPartyId);
    if (!user?.lastOnline) return "Unavailable";
    const lastOnlineDate = new Date(user.lastOnline);
    const now = new Date();
    const isToday = lastOnlineDate.toDateString() === now.toDateString();
    const isYesterday =
      new Date(now.setDate(now.getDate() - 1)).toDateString() ===
      lastOnlineDate.toDateString();
    if (isToday) {
      const hours = lastOnlineDate.getHours() % 12 || 12;
      const minutes = String(lastOnlineDate.getMinutes()).padStart(2, "0");
      const ampm = lastOnlineDate.getHours() >= 12 ? "PM" : "AM";
      return `${hours}:${minutes} ${ampm}`;
    } else if (isYesterday) {
      return "Yesterday";
    } else {
      const year = lastOnlineDate.getFullYear();
      const month = String(lastOnlineDate.getMonth() + 1).padStart(2, "0");
      const day = String(lastOnlineDate.getDate()).padStart(2, "0");
      return `${year}-${month}-${day}`;
    }
  };

  const handleVideoClick = async () => {
    if (!selectedConversation) {
      toast.warning("Please send a message before starting a meeting");
      return;
    }
    setLoading(true);
    const formData = {
      startTime: formatDate1(new Date()),
      needName: selectedConversation?.postName,
    };
    try {
      const linkResponse = await GetZoomLink(
        formData,
        selectedConversation?.Id
      );
      setZoomLink(linkResponse.join_url);
      await handleSend(linkResponse.join_url);
    } catch (error) {
      console.error("Error fetching Zoom link:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleSend = async (zoomLink) => {
    if (zoomLink.trim()) {
      const messageForm = {
        customerId:
          selectedConversation.customerId === user.UserID
            ? selectedConversation.createdBy
            : selectedConversation.customerId,
        postId: selectedConversation.postId,
        postType: 1,
        parentId:
          selectedConversation.parentId === 0
            ? selectedConversation.Id
            : selectedConversation.parentId,
        Description: `Click to join zoom meeting <br/> <a href="${zoomLink}" target="_blank" style="padding: 5px 15px; border-radius: 6px; border: 1px solid; background-color: #0D6EFD; color: white;">Join Call</a>`,
        messageStatus: 8,
        createdBy: user.UserID,
        roleId: user.RoleId,
        ownerId: selectedConversation.ownerId,
        userName: user.UserName.split("@")[0].trim(),
        Email: user.Email,
        serviceNeed: "need",
        needName: selectedConversation.postName,
      };
      const response = await sendMessage(messageForm);
      toast.success("Zoom link sent");
      if (response.Data) {
        let data = response.Data;
        if (data.parentId == 0) {
          dispatch(setSelectedConversation(data));
        } else {
          fetchMsgs();
        }
        sendNewMessage(response.Data);
        toast.success("Message Sent");
      }
      setTimeout(() => fetchMsgs(), 1000);
    }
    setZoomLink("");
  };

  const OnlineIndicator = () => {
    return (
      <div className="online-indicator">
        <span
          className={`status-dot ${online ? "online" : "offline"}`}
          title={online ? "Online" : "Offline"}
        ></span>
        {!online && (
          <span className="last-online">
            Last online: {formatLastOnline(otherPartyId)}
          </span>
        )}
      </div>
    );
  };

  const ActionButtons = () => {
    return (
      <div className="action-icons">
        <Tooltip title="Instant Call" placement="top" arrow>
          <span className="video-icon">
            {loading ? (
              <span
                className="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              />
            ) : (
              <FaVideo onClick={handleVideoClick} />
            )}
          </span>
        </Tooltip>
        {!isChatModal && (
          <MenuItems isMenuOpen={isMenuOpen} setIsMenuOpen={setIsMenuOpen} />
        )}
        {!isChatModal && isMobileView && (
          <span className="toggle-drawer-button" onClick={toggleDrawer}>
            <FaChevronRight />
          </span>
        )}
      </div>
    );
  };

  return (
    <div className="chat-header-container">
      <Row className="chat-header align-items-center m-0">
        {isMobileView && (
          <Col xs={2} className="back-button-col">
            <button onClick={onBack} className="back-button">
              ← Back
            </button>
          </Col>
        )}
        <Col xs={isMobileView ? 10 : 12} className="chat-header-content">
          <div className="chat-header-inner">
            {isMobileView ? (
              <>
                <div className="chat-title-mobile">
                  <h2 className="user-name">
                    {selectedConversation
                      ? selectedConversation?.createdBy !== user?.UserID
                        ? selectedConversation?.senderName?.trim() ||
                          "UnknownUser"
                        : selectedConversation?.customerName?.trim() ||
                          "UnknownUser"
                      : sampleAd && sampleAd?.firstName
                      ? `${sampleAd.firstName} ${
                          sampleAd.lastName || ""
                        }`.trim()
                      : sampleAd?.userName.split("@")[0].trim()}
                  </h2>
                </div>
                <div className="chat-actions-mobile">
                  <div className="online-indicator-col">
                    <OnlineIndicator />
                  </div>
                  <ActionButtons />
                </div>
              </>
            ) : (
              <div className="chat-title-desktop">
                <div className="chat-title-left">
                  <h2 className="user-name">
                    {selectedConversation
                      ? selectedConversation?.createdBy !== user?.UserID
                        ? selectedConversation?.senderName?.trim() ||
                          "UnknownUser"
                        : selectedConversation?.customerName?.trim() ||
                          "UnknownUser"
                      : sampleAd && sampleAd?.firstName
                      ? `${sampleAd.firstName} ${
                          sampleAd.lastName || ""
                        }`.trim()
                      : sampleAd?.userName.split("@")[0].trim()}
                  </h2>
                  <OnlineIndicator />
                </div>
                <ActionButtons />
              </div>
            )}
          </div>
        </Col>
      </Row>
      {!isChatModal && selectedConversation?.postType === 3 && (
        <AllDropdowns fetchData={fetchData} fetchMsgs={fetchMsgs} />
      )}
    </div>
  );
};

export default ChatHeader;
